import { cn } from "@/lib/utils";
import type { components } from "@dolfin/api-admin";

type RecurringScheduleStatus = components["schemas"]["RecurringScheduleStatus"];
type RecurrenceCadence = components["schemas"]["RecurrenceCadence"];
type ScheduleResponse = components["schemas"]["RecurringInvoiceScheduleResponse"];

export const CADENCE_NOUN: Record<RecurrenceCadence, string> = {
  Weekly: "week",
  Monthly: "month",
  Quarterly: "quarter",
  Annually: "year",
};

/** "Monthly · 3 of 12" / "Weekly · 8 generated" for list rows and detail headers. */
export function scheduleProgress(schedule: ScheduleResponse): string {
  const generated = schedule.occurrencesGenerated ?? 0;
  return schedule.totalOccurrences
    ? `${generated} of ${schedule.totalOccurrences}`
    : `${generated} generated`;
}

export function ScheduleStatusPill({ status }: { status: RecurringScheduleStatus | undefined }) {
  const tone =
    status === "Active"
      ? "border-emerald-500/30 bg-emerald-500/10 text-emerald-700"
      : status === "Paused"
        ? "border-amber-500/30 bg-amber-500/10 text-amber-700"
        : status === "Completed"
          ? "border-accent-blue/30 bg-accent-blue/10 text-accent-blue"
          : status === "Cancelled"
            ? "border-red-500/30 bg-red-500/10 text-red-700"
            : "border-border bg-muted text-muted-foreground";
  return (
    <span
      className={cn(
        "inline-flex min-w-[64px] justify-center rounded-md border px-2 py-0.5 text-[11px] font-medium",
        tone,
      )}
    >
      {status ?? "-"}
    </span>
  );
}
